
export default function ExampleListings() {
  const listings = [
    {
      title: 'Real Estate AI Marketing Agency',
      category: 'AI Agency',
      description: 'Full-service AI marketing automation for real estate professionals and brokerages',
      metrics: ['Monthly Revenue: $██,███', 'Active Clients: ██', 'Growth Rate: ██%'],
      tags: ['Real Estate', 'Marketing', 'Lead Gen']
    },
    {
      title: 'Legal AI Services Company',
      category: 'AIaaS',
      description: 'AI-powered document review and legal research services for law firms',
      metrics: ['MRR: $██,███', 'Law Firms: ███+', 'Retention: ██%'],
      tags: ['Legal', 'Document AI', 'B2B']
    },
    {
      title: 'Healthcare AI Automation Agency',
      category: 'AI Agency',
      description: 'Patient communication and administrative automation for medical practices',
      metrics: ['Revenue: $██,███/mo', 'Practices: ██+', 'Efficiency: ██%'],
      tags: ['Healthcare', 'Automation', 'Patient Care']
    },
    {
      title: 'Financial Services AI Company',
      category: 'AIaaS',
      description: 'Risk assessment and fraud detection AI solutions for financial institutions',
      metrics: ['ARR: $███,███', 'Banks: ██', 'Accuracy: ██%'],
      tags: ['FinTech', 'Risk Analysis', 'Enterprise']
    },
    {
      title: 'Manufacturing AI Optimization Agency',
      category: 'AI Agency',
      description: 'Predictive maintenance and quality control AI systems for manufacturers',
      metrics: ['Monthly: $██,███', 'Factories: ██', 'Savings: $█.█M'],
      tags: ['Manufacturing', 'Predictive AI', 'IoT']
    },
    {
      title: 'E-commerce AI Agency',
      category: 'AI Agency',
      description: 'Personalization and inventory optimization AI services for online retailers',
      metrics: ['MRR: $██,███', 'Stores: ███+', 'ROI: █.█x'],
      tags: ['E-commerce', 'Personalization', 'Retail']
    }
  ];

  return (
    <section className="py-32 relative">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-light tracking-tight mb-6">
            Example <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent font-medium">Listings</span>
          </h2>
          <p className="text-xl text-gray-300">
            Preview of verified A.I. businesses available to qualified members
          </p>
        </div>

        {/* Listings Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {listings.map((listing, index) => (
            <div key={index} className="group relative">
              {/* Card */}
              <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 group-hover:scale-105 cursor-pointer relative overflow-hidden">
                {/* Blur Overlay */}
                <div className="absolute inset-0 backdrop-blur-sm bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
                  <div className="text-center">
                    <i className="ri-lock-line text-3xl text-yellow-400 mb-3"></i>
                    <p className="text-white font-medium mb-2">Members Only</p>
                    <button className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-2 rounded-full text-sm font-medium hover:scale-105 transition-transform duration-200 whitespace-nowrap cursor-pointer">
                      Request Info
                    </button>
                  </div>
                </div>

                {/* Category Badge */}
                <div className="inline-flex items-center bg-gradient-to-r from-blue-500/20 to-purple-500/20 border border-blue-500/30 rounded-full px-3 py-1 text-sm text-blue-300 mb-6">
                  {listing.category}
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold mb-4 text-white">{listing.title}</h3>

                {/* Description */}
                <p className="text-gray-400 mb-6 leading-relaxed">{listing.description}</p>

                {/* Blurred Metrics */}
                <div className="space-y-2 mb-6">
                  {listing.metrics.map((metric, metricIndex) => (
                    <div key={metricIndex} className="text-sm text-gray-500 font-mono">
                      {metric}
                    </div>
                  ))}
                </div>

                {/* Tags */}
                <div className="flex flex-wrap gap-2">
                  {listing.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="bg-white/10 text-gray-300 px-3 py-1 rounded-full text-xs">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              {/* Verification Badge */}
              <div className="absolute -top-2 -right-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full p-2 shadow-lg">
                <i className="ri-shield-check-line text-white text-sm"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-400 mb-6">Ready to explore verified opportunities?</p>
          <button 
            onClick={() => window.open('https://form.typeform.com/to/p6aQCAhU', '_blank')}
            className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-4 rounded-full font-medium hover:scale-105 transition-transform duration-200 whitespace-nowrap cursor-pointer"
          >
            Apply for Portal Access
          </button>
        </div>
      </div>
    </section>
  );
}
